import PropTypes from 'prop-types';
import * as React from 'react';
import './styles.scss';
import {ListItem} from './';

export default class ListComponent extends React.Component {
  render() {
    if (this.props.loading)
      return (
        <ul className="list">
          <ListItem loading secondaryText={this.props.loadingText} />
        </ul>
      );

    return (
      <ul className="list">
        {this.props.children}
      </ul>
    );
  }
}

ListComponent.propTypes = {
  error: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  loadingText: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/component/list/list-component.js